import React from 'react';
import TextField from '@material-ui/core/TextField';
import { handleShowError, handleError } from 'utils';
import { useStyles } from './DisclaimerField.styled';
import clsx from 'clsx';
import i18n from 'i18n-js';
import { useState } from 'react';
import { Box, Button, Grid, Typography } from '@material-ui/core';
import { Edit } from '@material-ui/icons';

const DisclaimerField = ({
  field: { name, value, onChange, onBlur },
  classname,
  form: { errors, touched, setFieldValue, initialValues },
  meta,
  label,
  required,
  variant,
  fullWidth,
  disabled,
  inputProps,
  rows,
  asyncErrors,
  margin,
  editable = true,
  ...props
}) => {
  const classes = useStyles();
  const [isEditing, setEditMode] = useState(false);
  const [initValue, setInitValue] = useState(value);

  const isEmpty = !value || value === '';
  return (
    <Grid container className={classes.container}>
      <Grid item xs={6}>
        <Typography variant="h6" className={classes.description}>
          <Box fontWeight="bold" fontSize={14} lineHeight={2.5}>
            {i18n.t('reservation_rulesets.disclaimer')}
          </Box>
        </Typography>
      </Grid>
      <Grid item xs={6} className={classes.actionMenu}>
        {editable ? (
          <Button
            data-cy="disclaimer-edit-btn"
            startIcon={<Edit />}
            onClick={() => setEditMode(!isEditing)}
            color="primary"
          >
            {i18n.t('common.edit')}
          </Button>
        ) : null}
      </Grid>
      <Grid item xs={12}>
        {!isEmpty || isEditing ? (
          <TextField
            multiline
            rows={rows}
            name={name}
            label={label}
            value={value}
            margin={margin}
            onBlur={onBlur}
            variant={variant}
            onChange={onChange}
            required={required}
            disabled={!isEditing}
            fullWidth={fullWidth}
            className={clsx(
              classes.textField,
              !isEditing && classes.textFieldIsNotEditing,
              classname
            )}
            InputProps={{
              disableUnderline: !isEditing,
            }}
            inputProps={{
              className: clsx(classes.textArea, isEditing && classes.isEditing),
            }}
            error={handleError(name, errors, touched, asyncErrors)}
            helperText={handleShowError(name, errors, touched, asyncErrors)}
            {...props}
          />
        ) : (
          <div className={clsx(classes.textField, classes.textareaEmpty)}>
            {i18n.t('reservation_rulesets.no_disclaimer')}
          </div>
        )}
      </Grid>
      {isEditing && (
        <Grid container className={classes.editActions}>
          <Grid item>
            <Button
              data-cy="disclaimer-cancel-btn"
              variant="outlined"
              className={clsx(classes.button, classes.cancelButton)}
              onClick={() => {
                setFieldValue(name, initValue);
                setEditMode(false);
              }}
              color="primary"
            >
              {i18n.t('common.cancel')}
            </Button>
          </Grid>
          <Grid item className={classes.actionMenu}>
            <Button
              data-cy="disclaimer-save-btn"
              className={classes.button}
              variant="contained"
              onClick={() => {
                setInitValue(value);
                setEditMode(false);
              }}
              color="primary"
            >
              {i18n.t('common.save')}
            </Button>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export { DisclaimerField };
